export const columns = (viewPartsDetail) => {
  return [
    {
      title: "Model ID",
      dataIndex: "id",
      key: "id",
      render: (_,record, index) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{index +1}</div>,
    },
    {
      title: "Model Name",
      dataIndex: "name",
      key: "name",
      onClick: viewPartsDetail,
    },
    {
      title: "Manufacturer Name",
      dataIndex: "manufacturerName",
      key: "manufacturerName",
    },
  ];
};

export const vehicleColumns = (viewPartsDetail) => {
  return [
    {
      title: "Model ID",
      dataIndex: "id",
      key: "id",
      align: "center",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record.partModelId}</div>,
    },
    {
      title: "Model Name",
      dataIndex: "name",
      key: "name",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record?.name}</div>,
    },
    {
      title: "Manufacturer Name",
      dataIndex: "manufacturerName",
      key: "manufacturerName",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record?.manufacturerName}</div>,
    },
    // {
    //   title: "Edit",
    //   dataIndex: "edit",
    //   key: "edit",
    // },
    // {
    //   title: "Clone",
    //   dataIndex: "clone",
    //   key: "clone",
    // },
  ];
};
